import createSvgIcon from '@material-ui/core/utils/createSvgIcon';

const ErrorCircle = createSvgIcon(
  <svg
    width="23"
    height="17"
    viewBox="0 0 23 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.59124 17V15.8753H6.19686L8.25371 8.74013C8.35813 8.33898 8.56805 8.02181 8.88348 7.78862C9.1989 7.55543 9.55157 7.43921 9.94148 7.43996H13.0585C13.4492 7.43996 13.8018 7.55618 14.1165 7.78862C14.432 8.02181 14.6419 8.33898 14.7463 8.74013L16.8031 15.8753H18.4088V17H4.59124ZM10.9524 4.49884V0H12.0476V4.49884H10.9524ZM16.9214 7.04406L16.1405 6.24214L19.2488 3.07721L20.0034 3.85213L16.9214 7.04406ZM18.619 12.3718V11.2471H23V12.3718H18.619ZM6.07857 7.04294L2.99767 3.85213L3.75119 3.07721L6.86057 6.24214L6.07857 7.04294ZM0 12.3718V11.2471H4.38095V12.3718H0Z"
      fill="white"
    />
  </svg>,
  'ErrorCircle'
);

export default ErrorCircle;
